module.exports = __webpack_public_path__ + "img/1.9ba66da2.jpg";